import { render, staticRenderFns } from "./SelectableCard.vue?vue&type=template&id=019b05e0"
import script from "./SelectableCard.vue?vue&type=script&lang=ts"
export * from "./SelectableCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports